export const TOKEN_INITIAL_STATE = {
  token: '',
  loadedAt: new Date().toJSON(),
};
export const SET_TOKEN = 'SET_TOKEN';
